import { useAuthModal, useOverlay } from 'contexts'
import { useRouter } from 'next/router'
import { Suspense, lazy, useEffect } from 'react'

const AuthModal = lazy(() =>
  import('components/common/AuthModal').then(m => ({ default: m.AuthModal }))
)

export function AuthModalObserver() {
  const { isOpen, state, config, setState, setConfig, setIsOpen } =
    useAuthModal()
  const { setConfig: setOverlayConfig } = useOverlay()
  const router = useRouter()

  useEffect(() => {
    if (!isOpen) {
      setState(undefined)
      setConfig({ closeable: true })
      config.onClose?.()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  useEffect(() => {
    if (!state) {
      setOverlayConfig({})
      return
    }

    setOverlayConfig({
      className: 'lg:flex sm:items-center',
      body: (
        <Suspense>
          <AuthModal />
        </Suspense>
      ),
      closeable: config.closeable,
    })
  }, [state, setOverlayConfig, config])

  useEffect(() => {
    const accountExists = () => {
      const fairartUserExists = router.query.fairartUserExists === 'true'
      const fairartUserExistsNotGoogle =
        router.query.fairartUserExistsNotGoogle === 'true'
      const fairartUserExistsNotApple =
        router.query.fairartUserExistsNotApple === 'true'

      return (
        fairartUserExists ||
        fairartUserExistsNotApple ||
        fairartUserExistsNotGoogle
      )
    }

    const shouldDisplaySignUp = () => {
      return (
        router.query.action === 'sign-up' ||
        typeof router.query.signup !== 'undefined'
      )
    }

    const determineModal = () => {
      if (accountExists()) {
        setState('login')
        setIsOpen(true)

        return
      }

      if (shouldDisplaySignUp()) {
        setState('register')
        setIsOpen(true)
        router.replace(
          { pathname: router.asPath.split('?')[0], query: {} },
          undefined,
          {
            shallow: true,
          }
        )

        return
      }
    }

    determineModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    router.query.fairartUserExists,
    router.query.fairartUserExistsNotGoogle,
    router.query.fairartUserExistsNotApple,
    router.query.action,
    router.query.signup,
  ])

  return null
}
